import React from 'react';
import { Modal, Form, Input, Radio, Alert, Button, Popconfirm } from 'antd';

import stickyError from 'components/stickyError';

class ACHModalForm extends React.Component {
	handleSubmit = (event) => {
		event.preventDefault();
		this.props.form.validateFields((errors, values) => {
			if (errors) return stickyError('Validation error');
			else this.props.onSubmit(values);
		});
	}
	render() {
		const { getFieldDecorator } = this.props.form;
		const amount = parseFloat(Math.round(this.props.total * 100) / 100).toFixed(2);
		const eChecksAreWorking = true;
		return (
			<Modal
				closable={false}
				visible={this.props.visible}
				footer={[
					<Popconfirm
						title={"Are you sure you want to make a $"+amount+" payment via eCheck?"}
						onConfirm={(eChecksAreWorking)? this.handleSubmit: this.props.onCancel}>
						<Button type="primary" loading={this.props.loading}>{(eChecksAreWorking)? "Pay by eCheck": "Ok"}</Button>
					</Popconfirm>,
					<Button onClick={this.props.onCancel}>Cancel</Button>
				]}>
				
				{(!eChecksAreWorking)?
					<Alert showIcon type="warning"
						message="Sorry for the delay"
						description={
							<p>
								We are currently unable to process eChecks - this feature should be back online soon
								<br /><br />
								Alternative payment options include: check by mail payable in U.S. funds, E-check or credit card (Visa, Mastercard, Discover, American Express).
							</p>
						} />
				:
					<Form>
						<Form.Item label="Amount">
							{getFieldDecorator('amount', {
								initialValue: amount
							})(
								<Input disabled />
							)}
						</Form.Item>
						<legend>Bank Account Information</legend>
						<Form.Item label="Account Holder (Full Name)">
							{getFieldDecorator('billTo', {
								rules: [{required: true, message: 'This is a required field'}]
							})(
								<Input />
							)}
						</Form.Item>
						<Form.Item label="Account Type">
							{getFieldDecorator('CheckType', {
								rules: [{required: true, message: 'Please specify the check type'}]
							})(
								<Radio.Group>
									<Radio value="0">Personal</Radio>
									<Radio value="1">Business/Corporate</Radio>
								</Radio.Group>
							)}
						</Form.Item>
						<Form.Item label="Routing Number">
							{getFieldDecorator('routingNumber', {
								rules: [
									{required: true, message: 'This is a required field'},
									{max: 9, message: 'Routing Number cannot be longer than 9 characters'}
								]
							})(
								<Input />
							)}
						</Form.Item>
						<Form.Item label="Account Number">
							{getFieldDecorator('accountNumber', {
								rules: [
									{required: true, message: 'This is a required field'},
									{max: 20, message: 'Account Number cannot be longer than 20 characters'}
								]
							})(
								<Input />
							)}
						</Form.Item>
					</Form>
				}
			</Modal>
		);
	}
}

export default Form.create()(ACHModalForm);



// WEBPACK FOOTER //
// ./src/containers/PaymentTriggerForm/ACHModalForm.jsx